import React, { ReactElement } from 'react';
import { withRequireOnboarding } from 'src/components/withRequireOnboarding';
import PolicyEnginePage from './policyengine/Main';
import { usePageTitle } from 'src/hooks/useMastheadTitle';

export default function PolicyEngineRoute(): ReactElement {
	usePageTitle('Policies');
	const Page = withRequireOnboarding(PolicyEnginePage);

	return <Page />;
}
